import { render, staticRenderFns } from "./CategoryModify.vue?vue&type=template&id=9cd6d526&scoped=true&"
import script from "./CategoryModify.vue?vue&type=script&lang=js&"
export * from "./CategoryModify.vue?vue&type=script&lang=js&"
import style0 from "./CategoryModify.vue?vue&type=style&index=0&id=9cd6d526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd6d526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
